<app-modal class="app-send-email-popup">
	<form modal-body class="app-send-email-popup__body" [formGroup]="form">
		<dc-alert
			[type]="'info'"
			message="message"
			i18n-message="@@project.send-email-popup.contact-details-info"></dc-alert>
		<mat-form-field>
			<mat-label i18n="@@project.send-email-popup.title">title</mat-label>
			<input
				type="text"
				id="{{ cmpId + '-title-input' }}"
				matInput
				[formControlName]="SendEmailFormControls.Title" />
			<mat-hint [align]="'end'">
				{{ form.get(SendEmailFormControls.Title)?.value?.length || 0 }}/{{
					configuration.maxLengthProjectEmailTitle
				}}
			</mat-hint>
			<mat-error
				*ngIf="
					form
						.get(SendEmailFormControls.Title)
						?.hasError(ValidationErrorKeys.Maxlength)
				">
				<span i18n="@@general.form.errors.maxlength">max-length</span>
			</mat-error>
			<mat-error
				*ngIf="
					form
						.get(SendEmailFormControls.Title)
						?.hasError(ValidationErrorKeys.Required)
				">
				<span i18n="@@general.form.errors.required">required</span>
			</mat-error>
		</mat-form-field>
		<div class="html-editor">
		<dx-html-editor
			height="20rem"
			[formControlName]="SendEmailFormControls.Message">
			<dxo-toolbar [multiline]="true">
				<dxi-item name="undo"></dxi-item>
				<dxi-item name="redo"></dxi-item>
				<dxi-item name="separator"></dxi-item>
				<dxi-item
					name="size"
					[acceptedValues]="[
						'8pt',
						'10pt',
						'12pt',
						'14pt',
						'18pt',
						'24pt',
						'36pt'
					]"
					[options]="{ inputAttr: { 'aria-label': 'Font size' } }"></dxi-item>
				<dxi-item
					name="font"
					[acceptedValues]="[
						'Arial',
						'Courier New',
						'Georgia',
						'Impact',
						'Lucida Console',
						'Tahoma',
						'Times New Roman',
						'Verdana'
					]"
					[options]="{ inputAttr: { 'aria-label': 'Font family' } }"></dxi-item>
				<dxi-item name="separator"></dxi-item>
				<dxi-item name="bold"></dxi-item>
				<dxi-item name="italic"></dxi-item>
				<dxi-item name="strike"></dxi-item>
				<dxi-item name="underline"></dxi-item>
				<dxi-item name="separator"></dxi-item>
				<dxi-item name="alignLeft"></dxi-item>
				<dxi-item name="alignCenter"></dxi-item>
				<dxi-item name="alignRight"></dxi-item>
				<dxi-item name="alignJustify"></dxi-item>
				<dxi-item name="separator"></dxi-item>
				<dxi-item name="orderedList"></dxi-item>
				<dxi-item name="bulletList"></dxi-item>
				<dxi-item name="separator"></dxi-item>
				<dxi-item
					name="header"
					[acceptedValues]="[false, 1, 2, 3, 4, 5]"
					[options]="{ inputAttr: { 'aria-label': 'Header' } }"></dxi-item>
				<dxi-item name="separator"></dxi-item>
				<dxi-item name="color"></dxi-item>
				<dxi-item name="background"></dxi-item>
				<dxi-item name="separator"></dxi-item>
				<dxi-item name="link"></dxi-item>
				<dxi-item name="separator"></dxi-item>
				<dxi-item name="clear"></dxi-item>
				<dxi-item name="codeBlock"></dxi-item>
				<dxi-item name="blockquote"></dxi-item>
			</dxo-toolbar>
			<dxo-media-resizing [enabled]="true"></dxo-media-resizing>
			<dxo-image-upload fileUploadMode="base64"></dxo-image-upload>
		</dx-html-editor>
			<mat-error
				*ngIf="
					form
						.get(SendEmailFormControls.Message)
						?.hasError(ValidationErrorKeys.Maxlength)
				">
				<span i18n="@@general.form.errors.maxlength">max-length</span>
			</mat-error>
			<mat-error
				*ngIf="
				form.get(SendEmailFormControls.Message)?.touched &&
					form
						.get(SendEmailFormControls.Message)
						?.hasError(ValidationErrorKeys.Required)
				">
				<span i18n="@@general.form.errors.required">required</span>
			</mat-error>
		</div>
	</form>
	<div modal-footer class="app-send-email-popup__footer">
		<ng-container>
			<button
				id="{{ cmpId }}-send-email-btn"
				class="app-send-email-popup__footer__btn"
				(click)="sendEmail()"
				[color]="'primary'"
				[disabled]="!form.valid"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Email"></mat-icon>
				<span i18n="@@project.send-email-popup.send">send</span>
			</button>
		</ng-container>
	</div>
</app-modal>
